import { CommonMsgNodeProps, TextMessageType } from '@/types/message'
// import Bubble from '../bubble'
import Bubble from '../bubble-new'
import styles from './index.module.scss'
import React from 'react'

interface TextMsgProps extends CommonMsgNodeProps {
  node: TextMessageType
  typing?: boolean
}

const TextMsg = (props: TextMsgProps) => {
  const { node, msgContent, onTypingComplete, useTypingComplete } = props

  const { value, display = 'block' } = node
  const placement = msgContent?.placement || 'start'
  const isStart = placement === 'start'
  const isBlockLayout = display === 'block' && !isStart

  if (isStart) {
    return (
      <Bubble
        className={styles.text}
        style={{
          display: isBlockLayout ? 'flex' : 'inline'
        }}
        onTypingComplete={() => {
          onTypingComplete?.()
        }}
        typing={useTypingComplete}
        content={value}
      />
    )

    // return <span
    //   className={styles.text}
    //   style={{
    //     display: isBlockLayout ? 'block' : 'inline',
    //     overflowWrap: 'break-word',
    //   }}
    // >
    //   <Bubble
    //     style={{
    //       display: isBlockLayout ? 'flex' : 'inline-flex',
    //       overflowWrap: 'break-word',
    //     }}
    //     onTypingComplete={() => {
    //       onTypingComplete?.()
    //     }}
    //     typing={useTypingComplete}
    //     content={value} />
    // </span>
  }

  return (
    <span className={styles.rightTextBox}>
      <span className={styles.rightText}>
        <Bubble
          onTypingComplete={() => {
            onTypingComplete?.()
          }}
          typing={false}
          content={typeof value === 'string' ? value : JSON.stringify(value)}
          // content={<span className='y-text-white'>{value}</span>}
        />
      </span>
    </span>
  )
}

export default React.memo(TextMsg)
